import { useCreateFieldGetter } from '@/common/customisation/composables';
import { PUI } from '@pleased-npm/fe-customisation';

/**
 * Composable for MessageActions component customisation
 * Returns styling for suggestion chips/action items
 */
export const useMessageActionsCustomisation = () => {
  // Suggestions customisation
  const { getField: getSuggestionsField } = useCreateFieldGetter({
    registryId: PUI.REGISTRY_IDS.CHATBOT,
    sectionKey: PUI.CHATBOT_SECTION_KEYS.SUGGESTIONS,
    blockKey: PUI.CHATBOT_BLOCK_KEYS.CHATBOT,
  });

  const suggestionsTextColor = getSuggestionsField(PUI.COMMON_FIELD_KEYS.TEXT_COLOR);
  const suggestionsBackgroundColor = getSuggestionsField(PUI.COMMON_FIELD_KEYS.BACKGROUND_COLOR);
  const suggestionsBorderColor = getSuggestionsField(PUI.COMMON_FIELD_KEYS.BORDER_COLOR);
  const suggestionsSelectedBorderColor = getSuggestionsField(PUI.COMMON_FIELD_KEYS.SELECTED_BORDER_COLOR);

  return {
    suggestionsTextColor,
    suggestionsBackgroundColor,
    suggestionsBorderColor,
    suggestionsSelectedBorderColor,
  };
};
